<template>
    <a-select :mode="props.mode" v-model:value="state.value" :placeholder="props.placeholder" @change="changeValue"
        option-filter-prop="label" allow-clear>
        <a-select-opt-group v-for="(item, index) in state.platformList" :key="index" :label="item.label">
            <a-select-option v-for="(son, idx) in item.children" :key="idx + '_' + index" :value="son.buss_id">
                {{ item.label }}_{{
                    son.platform_name
                }}</a-select-option>
        </a-select-opt-group>
    </a-select>
</template>
<script lang="ts" setup>
import { reactive, ref, onMounted, h, watch } from 'vue'
import { message, Modal, Table } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
const emit = defineEmits(['update:value', 'change'])
const props = defineProps({
    value: {
        type: [String, Array],
        default: []
    },
    type: {//类型，chongzhi只显示充值的平台
        type: String,
        default: 'user'
    },
    placeholder: {
        type: String,
        default: '请选择业务平台'
    },
    mode: {
        //multiple 是多选，undefined是单选
        type: String,
        default: undefined
    }
})
const state = reactive<any>({
    platformList: [],
    value: null
})
onMounted(() => {
    if (props.mode == 'multiple') {
        if (props.value && Array.isArray(props.value)) {
            state.value = props.value.map(String)
        } else {
            state.value = []
        }
    } else {
        if (props.value) {
            state.value = String(props.value)
        } else {
            state.value = null
        }
    }
    platformList()
})
// 获取平台数据
const platformList = () => {
    // 获取到列表数据
    let requestParam = {
        url: '/admin/v1/busstype/bussplatform',
        method: 'post',
        data: { limit: 'all', type: props.type }
    }
    baseService(requestParam)
        .then((res) => {
            state.platformList = res.data
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('平台列表查询失败,请联系管理员')
            }
        })
}
// 根据 buss_id 查找完整的平台对象
const findPlatformById = (id: string) => {
    for (const group of state.platformList) {
        const found = group.children.find((item: any) => item.buss_id === id)
        if (found) {
            return found
        }
    }
    return null
}

// 根据 buss_id 数组查找完整的平台对象数组
const findPlatformsByIds = (ids: string[]) => {
    const result: any[] = []
    for (const id of ids) {
        const platform = findPlatformById(id)
        if (platform) {
            result.push(platform)
        }
    }
    return result
}
//改变值
const changeValue = (value: any) => {
    emit('update:value', state.value)
    // change 事件传完整对象
    if (props.mode == 'multiple') {
        if (state.value && Array.isArray(state.value) && state.value.length) {
            const platforms = findPlatformsByIds(state.value)
            emit('change', platforms)
            return
        }
        emit('change', [])
        return
    } else {
        if (value) {
            const platform = findPlatformById(String(value))
            if (platform) {
                emit('change', platform)
                return
            }
        }
        emit('change', null)
    }
}
watch(
    () => props.value,
    (val) => {
        if (val) {
            if (props.mode == 'multiple') {
                if (props.value && Array.isArray(props.value)) {
                    state.value = props.value.map(String)
                } else {
                    state.value = []
                }
            } else {
                if (props.value) {
                    state.value = String(props.value)
                } else {
                    state.value = null
                }
            }
        }
    },
    {
        deep: true,
        immediate: true
    }
)
</script>
